const England = {
  type: 'Feature',
  properties: {
    centre: [52.47, -1.92]
  },
  geometry: {
    coordinates: [
      [
        [
          -2.4404584356565806,
          55.40940595364748
        ],
        [
          -2.6010737235502575,
          55.281971828328665
        ],
        [
          -2.7336996862976264,
          55.192126754753815
        ],
        [
          -3.009399673241205,
          55.06502486601386
        ],
        [
          -3.06196715670859,
          54.99748832055403
        ],
        [
          -3.2310839663677484,
          54.96011228670659
        ],
        [
          -3.347902645217573,
          54.90006908323065
        ],
        [
          -3.42527523928419,
          54.780033306046136
        ],
        [
          -3.5796663178844312,
          54.68990807688229
        ],
        [
          -3.629871512778209,
          54.54012283762356
        ],
        [
          -3.1691507769467933,
          54.09248789802271
        ],
        [
          -3.0159645374383786,
          54.21904451801046
        ],
        [
          -2.9528451858608946,
          54.15921740254251
        ],
        [
          -2.8507167279158807,
          54.19621332481876
        ],
        [
          -2.7757824776128643,
          54.09152405523707
        ],
        [
          -2.8777890596559814,
          54.04715678497922
        ],
        [
          -2.8913164208198623,
          53.965222635180055
        ],
        [
          -3.0053700653321016,
          53.9357266357697
        ],
        [
          -3.0318397719226766,
          53.75706556779042
        ],
        [
          -2.906242287190139,
          53.734412036472264
        ],
        [
          -3.0579253927049876,
          53.60083837227259
        ],
        [
          -3.0584013529923766,
          53.519007876819444
        ],
        [
          -3.0338127204325644,
          53.45201695421727
        ],
        [
          -2.884990761960438,
          53.347492515935784
        ],
        [
          -2.6732038858114606,
          53.34659673104551
        ],
        [
          -2.9105867363338973,
          53.27321520077197
        ],
        [
          -3.0465236132642417,
          53.414857532874464
        ],
        [
          -3.196301420997429,
          53.385323849270634
        ],
        [
          -3.0599221470430393,
          53.251291587173085
        ],
        [
          -2.911396225785012,
          53.183991376206734
        ],
        [
          -2.986344197770194,
          53.150842028802
        ],
        [
          -2.927790233593754,
          53.115712248458095
        ],
        [
          -2.8848506598640142,
          53.115712248458095
        ],
        [
          -2.880947062252318,
          53.078208818643645
        ],
        [
          -2.8262966956875744,
          52.99605605390616
        ],
        [
          -2.767742731511106,
          52.99370653171249
        ],
        [
          -2.7208995601696984,
          52.979606713930565
        ],
        [
          -2.7248031577813947,
          52.92551476812062
        ],
        [
          -2.79897151240462,
          52.90197542601078
        ],
        [
          -2.8497182813576956,
          52.941984696130305
        ],
        [
          -2.927790233593754,
          52.939632232995535
        ],
        [
          -2.9746334049351617,
          52.96550229347565
        ],
        [
          -3.037090966723298,
          52.927867998717744
        ],
        [
          -3.087837735676402,
          52.927867998717744
        ],
        [
          -3.1502952974645098,
          52.873711325734206
        ],
        [
          -3.1620060903007072,
          52.79116907918467
        ],
        [
          -3.09174133328807,
          52.79116907918467
        ],
        [
          -3.009765783440315,
          52.7675567655063
        ],
        [
          -2.970729807323437,
          52.72265807026727
        ],
        [
          -3.025380173888209,
          52.72265807026727
        ],
        [
          -3.0683197476179487,
          52.63035260288541
        ],
        [
          -3.1034521261231305,
          52.587684278030736
        ],
        [
          -3.142488102241174,
          52.58531259646185
        ],
        [
          -3.1190665165710243,
          52.533103126037105
        ],
        [
          -2.9902477953818902,
          52.582940786549756
        ],
        [
          -2.9980549906052545,
          52.52122867097381
        ],
        [
          -3.185427675970857,
          52.4736987419856
        ],
        [
          -3.2283672497005966,
          52.4475353770471
        ],
        [
          -3.2127528592538113,
          52.418975790014485
        ],
        [
          -3.115162918959328,
          52.37848468803779
        ],
        [
          -3.0448977304090477,
          52.340342115589465
        ],
        [
          -2.9590185829496534,
          52.347496477332584
        ],
        [
          -2.9590185829496534,
          52.32602991885605
        ],
        [
          -2.994150961455972,
          52.31887208371364
        ],
        [
          -2.9980545590676684,
          52.27828914328097
        ],
        [
          -2.955114985337957,
          52.26873481086278
        ],
        [
          -3.0527049256324403,
          52.24483996903828
        ],
        [
          -3.1073552921972123,
          52.16110661571861
        ],
        [
          -3.130776877868527,
          52.137153815677806
        ],
        [
          -3.1073552921972123,
          52.110790850835826
        ],
        [
          -3.1073552921972123,
          52.065218081536216
        ],
        [
          -3.0917409017504838,
          52.01719645313656
        ],
        [
          -3.005861754291061,
          51.93303442032152
        ],
        [
          -2.9629221805613497,
          51.906550838316434
        ],
        [
          -2.8770430331018986,
          51.92822038561667
        ],
        [
          -2.767742299972383,
          51.877641837672854
        ],
        [
          -2.732609921467173,
          51.83183121284287
        ],
        [
          -2.6545379692311144,
          51.82700632863131
        ],
        [
          -2.6740565360126425,
          51.778729987622114
        ],
        [
          -2.670152938401003,
          51.737653650536345
        ],
        [
          -2.677960133624339,
          51.70379801771335
        ],
        [
          -2.658442145565914,
          51.62147162897185
        ],
        [
          -2.5842737909415803,
          51.684440559209236
        ],
        [
          -2.5218162291534156,
          51.706217117910825
        ],
        [
          -2.4164190936355396,
          51.76906832867894
        ],
        [
          -2.3734795199058567,
          51.76182072701502
        ],
        [
          -2.6311169622829595,
          51.60692791268741
        ],
        [
          -2.724803304965775,
          51.490410360250166
        ],
        [
          -2.8975853957721824,
          51.3942428457336
        ],
        [
          -3.0336159948725197,
          51.26391231955188
        ],
        [
          -3.0064098750519292,
          51.20713129585988
        ],
        [
          -3.12430306093799,
          51.21281255182461
        ],
        [
          -3.405432965743671,
          51.17871450175241
        ],
        [
          -3.5686696846632344,
          51.22417296114256
        ],
        [
          -4.2034791471272115,
          51.20144933898331
        ],
        [
          -4.248822680160629,
          51.12752010276532
        ],
        [
          -4.194410440520784,
          51.070570809220555
        ],
        [
          -4.339509746227492,
          50.97359596807752
        ],
        [
          -4.52995258496631,
          51.036367556352786
        ],
        [
          -4.5662274113932995,
          50.962173825288374
        ],
        [
          -4.557158704785536,
          50.80769988843292
        ],
        [
          -4.665983184065254,
          50.71017563731917
        ],
        [
          -4.783876369951344,
          50.606693065836
        ],
        [
          -5.019662741724915,
          50.52604893585743
        ],
        [
          -5.037800154937742,
          50.39904348203888
        ],
        [
          -5.137555927611032,
          50.393262401743186
        ],
        [
          -5.1738307540367146,
          50.31804419203584
        ],
        [
          -5.4730980720552225,
          50.1614407944401
        ],
        [
          -5.51844160508864,
          50.2136990935185
        ],
        [
          -5.708884443828765,
          50.14982007293443
        ],
        [
          -5.690747030614602,
          50.03928231697532
        ],
        [
          -5.54564772490923,
          50.06839592453281
        ],
        [
          -5.500304191875841,
          50.12657015618953
        ],
        [
          -5.300792646529231,
          50.07421652647449
        ],
        [
          -5.228242993676531,
          49.957670225603465
        ],
        [
          -5.055937568150597,
          50.03345747571515
        ],
        [
          -5.128487221003269,
          50.109125303295315
        ],
        [
          -5.046868861544198,
          50.19628601399103
        ],
        [
          -4.965250502085098,
          50.14400865300405
        ],
        [
          -4.802013783165535,
          50.23690665126139
        ],
        [
          -4.738532836919262,
          50.352775097841516
        ],
        [
          -4.656914477458855,
          50.31804419203584
        ],
        [
          -4.439265518899418,
          50.352775097841516
        ],
        [
          -4.1762730273079285,
          50.323834439583976
        ],
        [
          -4.0402424282076765,
          50.306461580827914
        ],
        [
          -3.8316621762560317,
          50.225304283963396
        ],
        [
          -3.6412193375159063,
          50.202091079716496
        ],
        [
          -3.5868070978760613,
          50.323834439583976
        ],
        [
          -3.4870513252041064,
          50.38169812609044
        ],
        [
          -3.5596009780568068,
          50.445266747260234
        ],
        [
          -3.5051887384169618,
          50.491444907448056
        ],
        [
          -3.4779826185976788,
          50.67570678035682
        ],
        [
          -3.378226845924445,
          50.606693065836
        ],
        [
          -3.2240588336112808,
          50.67570678035682
        ],
        [
          -2.888516689165783,
          50.733140805269244
        ],
        [
          -2.4532187720483307,
          50.57790743462388
        ],
        [
          -2.3806691191942946,
          50.641212591897386
        ],
        [
          -1.9997834417167155,
          50.572148196100585
        ],
        [
          -1.9272337888626794,
          50.65271346970562
        ],
        [
          -2.0632643879630166,
          50.73888033876531
        ],
        [
          -1.8728215492241986,
          50.704432586697266
        ],
        [
          -1.6007603510249453,
          50.72165962814498
        ],
        [
          -1.2561494999730485,
          50.5663882534181
        ],
        [
          -1.0566379546264955,
          50.6814533488172
        ],
        [
          -1.2198746735460304,
          50.773302770611906
        ],
        [
          -1.138256314086874,
          50.80769988843292
        ],
        [
          -0.9115386489210948,
          50.79050449338715
        ],
        [
          -0.7845767564285495,
          50.72165962814498
        ],
        [
          -0.7029583969681426,
          50.779037381332614
        ],
        [
          -0.16790470717739936,
          50.82488895652878
        ],
        [
          0.2764619165477882,
          50.71591798445874
        ],
        [
          0.38528639582750657,
          50.83061724004003
        ],
        [
          0.6936224204524137,
          50.88214016559121
        ],
        [
          0.8024468997321321,
          50.93932111301339
        ],
        [
          0.983821031864494,
          50.91645716356871
        ],
        [
          1.0200958582914836,
          51.02496085783366
        ],
        [
          1.1651951639981917,
          51.08766296312396
        ],
        [
          1.4191189489832823,
          51.16734287687433
        ],
        [
          1.3737754159498081,
          51.331957070965245
        ],
        [
          1.4553937754103003,
          51.3942428457336
        ],
        [
          0.902202672405366,
          51.343288058162955
        ],
        [
          0.9475462054388117,
          51.399900988935286
        ],
        [
          0.7843094865192768,
          51.44514094232571
        ],
        [
          0.6120040609933142,
          51.47339317499478
        ],
        [
          0.41249251564676115,
          51.47904152306015
        ],
        [
          0.7843094865192768,
          51.52420313129596
        ],
        [
          0.929408792224649,
          51.60312828480326
        ],
        [
          0.9475462054388117,
          51.74934030728943
        ],
        [
          0.6573475940267031,
          51.70440226568627
        ],
        [
          1.065439391324901,
          51.77179257826046
        ],
        [
          1.2830883498843093,
          51.855889184499205
        ],
        [
          1.2105386970302732,
          51.88948389473285
        ],
        [
          1.4463124655603394,
          52.03477005909335
        ],
        [
          1.5732743580541921,
          52.11280666849851
        ],
        [
          1.663961424119691,
          52.30175665787203
        ],
        [
          1.7637171967929817,
          52.48990380073374
        ],
        [
          1.7365110769737555,
          52.671750747087685
        ],
        [
          1.5551369448400294,
          52.80901173532865
        ],
        [
          1.3284192796741934,
          52.91850946162498
        ],
        [
          1.0472893748685408,
          52.96769331695069
        ],
        [
          0.539441804898388,
          52.97315473870208
        ],
        [
          0.40341120579810763,
          52.814493185513896
        ],
        [
          0.19483095384649118,
          52.814493185513896
        ],
        [
          0.18576224723878454,
          52.87474352938881
        ],
        [
          0.004388115106365831,
          52.902102416436094
        ],
        [
          0.17669354063232845,
          53.03318484131043
        ],
        [
          0.3489989661583195,
          53.12579451521725
        ],
        [
          0.3217928463390365,
          53.29415848598569
        ],
        [
          0.18576224723878454,
          53.41324152686144
        ],
        [
          0.16762483402590078,
          53.494243851405
        ],
        [
          -0.022818004712917173,
          53.52121030096694
        ],
        [
          -0.1679173104195968,
          53.60200674298534
        ],
        [
          -0.2676730830928591,
          53.6987588679072
        ],
        [
          -0.050024124533507575,
          53.618147516411256
        ],
        [
          0.14041871420661778,
          53.618147516411256
        ],
        [
          -0.0046880363947821024,
          53.79528782581173
        ],
        [
          -0.1497873421001259,
          53.902283680675
        ],
        [
          -0.21326828834642697,
          54.019663440980594
        ],
        [
          -0.1860621685271724,
          54.104823060815505
        ],
        [
          -0.07723768924748242,
          54.11545573831245
        ],
        [
          -0.29488664780686236,
          54.189808152865396
        ],
        [
          -0.41277983369298,
          54.29050150425914
        ],
        [
          -0.5760165526124865,
          54.4806156665652
        ],
        [
          -0.7755280979577321,
          54.55957016507412
        ],
        [
          -1.0385205895505294,
          54.60161683616121
        ],
        [
          -1.2108260150765204,
          54.65411417940851
        ],
        [
          -1.310581787748447,
          54.80074654316289
        ],
        [
          -1.3559253207818642,
          54.92600950354651
        ],
        [
          -1.437543680242328,
          55.0664655990154
        ],
        [
          -1.5372994529142545,
          55.154648847241475
        ],
        [
          -1.5463681595219896,
          55.252976414057514
        ],
        [
          -1.5463681595219896,
          55.33559034253011
        ],
        [
          -1.591711692554071,
          55.42832554610564
        ],
        [
          -1.6370555866081702,
          55.556759939122514
        ],
        [
          -1.7549487724942594,
          55.6233825351153
        ],
        [
          -1.872841958380377,
          55.66432486085637
        ],
        [
          -1.9907351442664947,
          55.76649353720066
        ],
        [
          -2.0632847971192234,
          55.81747771172607
        ],
        [
          -2.144903156578323,
          55.715442602522415
        ],
        [
          -2.2265215160387584,
          55.63874092280824
        ],
        [
          -2.3262772887119922,
          55.63874092280824
        ],
        [
          -2.144903156578323,
          55.454042663040326
        ],
        [
          -2.3172085821042856,
          55.402583482811735
        ],
        [
          -2.380689528351809,
          55.34074390453483
        ],
        [
          -2.4404584356565806,
          55.40940595364748
        ]
      ]
    ],
    type: 'Polygon'
  }
}

const Scotland = {
  type: 'FeatureCollection',
  properties: {
    centre: [56.8, -4.1]
  },
  features: [
    { // Bowmore/Jura
      type: 'Feature',
      geometry: {
        coordinates: [
          [
            [
              -5.688375896029925,
              56.168241710129934
            ],
            [
              -6.009523060153157,
              55.993879127675115
            ],
            [
              -5.948765488563083,
              55.955024663646356
            ],
            [
              -6.061600978659527,
              55.93072080167184
            ],
            [
              -6.104999244082165,
              55.87232928715389
            ],
            [
              -6.148397509504747,
              55.92099498608181
            ],
            [
              -6.321990571192629,
              55.87232928715389
            ],
            [
              -6.443505714375448,
              55.86258882085082
            ],
            [
              -6.504263285966829,
              55.67705542517598
            ],
            [
              -6.321990571192629,
              55.75039778852988
            ],
            [
              -6.252553346517487,
              55.66237042483826
            ],
            [
              -6.330670224277668,
              55.628083987366296
            ],
            [
              -6.261232999602555,
              55.57905127877453
            ],
            [
              -6.1917957749260495,
              55.63298388765969
            ],
            [
              -6.009523060153157,
              55.68194920063482
            ],
            [
              -6.104999244082165,
              55.84310055907682
            ],
            [
              -5.974804447815558,
              55.804094709600975
            ],
            [
              -5.809891039211436,
              55.98902445376072
            ],
            [
              -5.688375896029925,
              56.168241710129934
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Mull
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -5.642151534310699,
              56.44510780913242
            ],
            [
              -5.701932549412163,
              56.47341991122292
            ],
            [
              -5.78733399955928,
              56.506424029880066
            ],
            [
              -5.847115014662052,
              56.51584850509346
            ],
            [
              -5.949596754837074,
              56.52762580438409
            ],
            [
              -5.983757334895415,
              56.57234616603074
            ],
            [
              -6.05207849501204,
              56.61231434900114
            ],
            [
              -6.094779220085599,
              56.649892858922954
            ],
            [
              -6.158830307695325,
              56.649892858922954
            ],
            [
              -6.222881395305052,
              56.60996444944962
            ],
            [
              -6.308282845450918,
              56.602913873403224
            ],
            [
              -6.308282845450918,
              56.57705049937954
            ],
            [
              -6.2698521928855655,
              56.58645741051032
            ],
            [
              -6.321093062973091,
              56.55587639024583
            ],
            [
              -6.321093062973091,
              56.53233569920573
            ],
            [
              -6.222881395305052,
              56.52762580438409
            ],
            [
              -6.158830307695325,
              56.48285258931793
            ],
            [
              -6.244231757841192,
              56.49228292332387
            ],
            [
              -6.295472627929996,
              56.48285258931793
            ],
            [
              -6.218611322798097,
              56.46870269303966
            ],
            [
              -6.137479945159214,
              56.46870269303966
            ],
            [
              -6.009377769939761,
              56.51349260595373
            ],
            [
              -6.009377769939761,
              56.461625766730435
            ],
            [
              -6.056348567520303,
              56.44510780913242
            ],
            [
              -6.133209872650951,
              56.44510780913242
            ],
            [
              -6.141750017666169,
              56.414412544495576
            ],
            [
              -6.19726096026065,
              56.3813283878265
            ],
            [
              -6.1844507427397275,
              56.35767924119983
            ],
            [
              -5.992297479910604,
              56.393147458646695
            ],
            [
              -6.000837624924571,
              56.36950564888943
            ],
            [
              -6.120399655130029,
              56.33401541702739
            ],
            [
              -6.222881395305052,
              56.33874935630905
            ],
            [
              -6.257041975363393,
              56.312705421779526
            ],
            [
              -6.393684295598007,
              56.34821547312046
            ],
            [
              -6.423574803149393,
              56.307968251820824
            ],
            [
              -6.3637937880466495,
              56.286643715770055
            ],
            [
              -6.28693248291475,
              56.27004973776451
            ],
            [
              -6.235691612827253,
              56.28427358830626
            ],
            [
              -6.060618640027286,
              56.293753216618114
            ],
            [
              -5.9965675524175595,
              56.331648227149685
            ],
            [
              -5.941056609821828,
              56.31744200425129
            ],
            [
              -5.889815739734303,
              56.35767924119983
            ],
            [
              -5.842844942153732,
              56.35058163532145
            ],
            [
              -5.87700552221213,
              56.31507378644892
            ],
            [
              -5.8257646521246045,
              56.307968251820824
            ],
            [
              -5.680582186875995,
              56.36950564888943
            ],
            [
              -5.642151534310699,
              56.44510780913242
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Scarinish / Coll
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -6.45430536991941,
              56.68536056715979
            ],
            [
              -6.512552963821321,
              56.68216126165413
            ],
            [
              -6.60866149375866,
              56.638944029713684
            ],
            [
              -6.62904815162338,
              56.62132280041348
            ],
            [
              -6.646522429794118,
              56.60048710123306
            ],
            [
              -6.698945264305479,
              56.579639904475385
            ],
            [
              -6.754280478511703,
              56.553966027204325
            ],
            [
              -6.78340427546263,
              56.53469918213028
            ],
            [
              -6.821265211498087,
              56.54112255327934
            ],
            [
              -6.853301388143905,
              56.533093169097725
            ],
            [
              -6.870775666314643,
              56.51542253068706
            ],
            [
              -6.946497538385529,
              56.526668435936585
            ],
            [
              -6.981446094727062,
              56.512208801852466
            ],
            [
              -6.978533715031347,
              56.4559244263406
            ],
            [
              -6.946497538385529,
              56.460752073005324
            ],
            [
              -6.926110880520838,
              56.441437804490505
            ],
            [
              -6.8882499444845,
              56.452705654337336
            ],
            [
              -6.8882499444845,
              56.47040552566892
            ],
            [
              -6.873688046009477,
              56.492920706095134
            ],
            [
              -6.8067033130230925,
              56.48488110365514
            ],
            [
              -6.789229034852326,
              56.50417328759224
            ],
            [
              -6.809615692717898,
              56.520242613048765
            ],
            [
              -6.719331922171079,
              56.53148708796377
            ],
            [
              -6.690208125220153,
              56.56199098574538
            ],
            [
              -6.658171948574335,
              56.579639904475385
            ],
            [
              -6.617398632843191,
              56.574827379745244
            ],
            [
              -6.515465343516155,
              56.616515582448386
            ],
            [
              -6.45430536991941,
              56.68536056715979
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Rum reserve & islands
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -6.603700738649195,
              57.048278261855955
            ],
            [
              -6.58848426259388,
              57.04092043911382
            ],
            [
              -6.549597712672437,
              57.056554070419566
            ],
            [
              -6.515783321436402,
              57.052876160981185
            ],
            [
              -6.5056390040665235,
              57.0445995326684
            ],
            [
              -6.473515332392651,
              57.0445995326684
            ],
            [
              -6.459989575897424,
              57.009633429628025
            ],
            [
              -6.395742232549708,
              56.97739870054522
            ],
            [
              -6.372072158685626,
              56.97371295362282
            ],
            [
              -6.3653092804380265,
              56.95343482474581
            ],
            [
              -6.338257767449619,
              56.94144710607972
            ],
            [
              -6.317969132707816,
              56.93499058402821
            ],
            [
              -6.213144519877517,
              56.88976362574127
            ],
            [
              -6.262175387168867,
              56.84448185831434
            ],
            [
              -6.275701143663042,
              56.83523394369621
            ],
            [
              -6.265556826293164,
              56.826908867153236
            ],
            [
              -6.246958911113495,
              56.83615883796318
            ],
            [
              -6.238505313304756,
              56.82505859880595
            ],
            [
              -6.221598117686256,
              56.83430902658276
            ],
            [
              -6.131989980912294,
              56.87405983585276
            ],
            [
              -6.126917822226858,
              56.88791646349392
            ],
            [
              -6.116773504855928,
              56.898998067372645
            ],
            [
              -6.1100106266083,
              56.92668769893089
            ],
            [
              -6.137062139597731,
              56.943291621376034
            ],
            [
              -6.25203106979896,
              56.96910525701111
            ],
            [
              -6.245268191551361,
              56.99398004823928
            ],
            [
              -6.238505313304756,
              57.008712824786045
            ],
            [
              -6.277391863225233,
              57.01423611206465
            ],
            [
              -6.245268191551361,
              57.02251950510427
            ],
            [
              -6.270628984978629,
              57.04184024666293
            ],
            [
              -6.333185608764211,
              57.05931226342611
            ],
            [
              -6.370381439123463,
              57.051037069643485
            ],
            [
              -6.465061734582889,
              57.04735861371739
            ],
            [
              -6.490422528010157,
              57.0583928885255
            ],
            [
              -6.490422528010157,
              57.06942388473706
            ],
            [
              -6.546216273549078,
              57.06850476026324
            ],
            [
              -6.607082177773549,
              57.05931226342611
            ],
            [
              -6.603700738649195,
              57.048278261855955
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Hebrides
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -7.6319493440743145,
              56.77717904304879
            ],
            [
              -7.629655706599777,
              56.79853645224162
            ],
            [
              -7.622774794177587,
              56.819881703162594
            ],
            [
              -7.570021132275997,
              56.852503872843926
            ],
            [
              -7.514973832899926,
              56.88008505190311
            ],
            [
              -7.505799283003199,
              56.917662978527716
            ],
            [
              -7.478275633315832,
              56.947698107078224
            ],
            [
              -7.427815608887386,
              56.956453798239295
            ],
            [
              -7.407172871620816,
              56.98145872823454
            ],
            [
              -7.3452446598225265,
              56.996453631042016
            ],
            [
              -7.324601922555985,
              57.01269129352261
            ],
            [
              -7.290197360446427,
              57.05512552738091
            ],
            [
              -7.271848260654366,
              57.08380356857887
            ],
            [
              -7.239737336017981,
              57.09626537052279
            ],
            [
              -7.219094598751468,
              57.11495022177792
            ],
            [
              -7.258086435810043,
              57.138604178119095
            ],
            [
              -7.3452446598225265,
              57.148559218663166
            ],
            [
              -7.262673710757667,
              57.154779759096016
            ],
            [
              -7.251205523387824,
              57.19083827052782
            ],
            [
              -7.262673710757667,
              57.21071756714227
            ],
            [
              -7.303959185289415,
              57.22437837585477
            ],
            [
              -7.260380073283159,
              57.2281031732731
            ],
            [
              -7.239737336017981,
              57.26781094787199
            ],
            [
              -7.207626411381568,
              57.28145061696179
            ],
            [
              -7.19845186148487,
              57.30375917807726
            ],
            [
              -7.225975511173601,
              57.32605421558736
            ],
            [
              -7.276435535602076,
              57.32605421558736
            ],
            [
              -7.219094598751468,
              57.34586067745684
            ],
            [
              -7.271848260654366,
              57.37555034985752
            ],
            [
              -7.184690036641882,
              57.3978018441488
            ],
            [
              -7.212213686329221,
              57.43238844180141
            ],
            [
              -7.232856423595791,
              57.44473288303661
            ],
            [
              -7.203039136433887,
              57.46200810460081
            ],
            [
              -7.152579112005469,
              57.50023134499605
            ],
            [
              -7.1319363747389275,
              57.55441503990377
            ],
            [
              -7.111293637472357,
              57.59131232047909
            ],
            [
              -7.072301800415147,
              57.64290570150095
            ],
            [
              -6.969087333693807,
              57.737303581834425
            ],
            [
              -6.895690934524254,
              57.776461504528555
            ],
            [
              -6.870460922311423,
              57.7740153772005
            ],
            [
              -6.868167284836915,
              57.7960245594696
            ],
            [
              -6.845230910097172,
              57.822906453474786
            ],
            [
              -6.8222945353561215,
              57.805802111853495
            ],
            [
              -6.794770885668754,
              57.805802111853495
            ],
            [
              -6.794770885668754,
              57.82901318094284
            ],
            [
              -6.744310861240308,
              57.82657061410757
            ],
            [
              -6.641097174908907,
              57.85587049276444
            ],
            [
              -6.650271724805606,
              57.922926205146524
            ],
            [
              -6.581462600585155,
              57.91561711261156
            ],
            [
              -6.5172407513123005,
              57.926580193627984
            ],
            [
              -6.473661639306073,
              57.93753992820308
            ],
            [
              -6.455312539514011,
              57.96918259141361
            ],
            [
              -6.455312539514011,
              57.99471975259388
            ],
            [
              -6.391090690241157,
              57.997150913932074
            ],
            [
              -6.354392490657119,
              58.03966952456986
            ],
            [
              -6.43466980224747,
              58.04695335636066
            ],
            [
              -6.365860678026962,
              58.054235703885894
            ],
            [
              -6.368154315501528,
              58.090625183993694
            ],
            [
              -6.388797052768041,
              58.100322782186254
            ],
            [
              -6.446137989617313,
              58.1039587018183
            ],
            [
              -6.436963439721978,
              58.1245552448909
            ],
            [
              -6.372741590449181,
              58.13182177175878
            ],
            [
              -6.377329715924844,
              58.182645470010954
            ],
            [
              -6.391091540769196,
              58.199570742604095
            ],
            [
              -6.352099703710621,
              58.18748208474713
            ],
            [
              -6.2924651293854765,
              58.20682196343324
            ],
            [
              -6.246592379906048,
              58.17659877608051
            ],
            [
              -6.20301326789982,
              58.20198798069032
            ],
            [
              -6.16172779336668,
              58.21769601938655
            ],
            [
              -6.134204143679312,
              58.262365495129615
            ],
            [
              -6.16172779336668,
              58.26357199760534
            ],
            [
              -6.207600542847473,
              58.24426302831563
            ],
            [
              -6.287877854437795,
              58.21044701876656
            ],
            [
              -6.326869691496398,
              58.22252786428436
            ],
            [
              -6.370448803502654,
              58.22373572274387
            ],
            [
              -6.317695141599671,
              58.2478842611969
            ],
            [
              -6.315401504126555,
              58.26960389386542
            ],
            [
              -6.278703304542432,
              58.26960389386542
            ],
            [
              -6.278703304542432,
              58.29372121212933
            ],
            [
              -6.237417830009321,
              58.299747975540924
            ],
            [
              -6.232830555061696,
              58.32023129547099
            ],
            [
              -6.166315068315754,
              58.34551784754149
            ],
            [
              -6.216775092742779,
              58.36597466466253
            ],
            [
              -6.191545080528584,
              58.408054333831586
            ],
            [
              -6.168608705788898,
              58.4284749184402
            ],
            [
              -6.191545080528584,
              58.44888366646438
            ],
            [
              -6.184664168107787,
              58.466881559028536
            ],
            [
              -6.221362367691825,
              58.48966566985348
            ],
            [
              -6.2603542047490635,
              58.51842448914016
            ],
            [
              -6.283290579490142,
              58.512435011212716
            ],
            [
              -6.271822392120299,
              58.49326181076569
            ],
            [
              -6.308520591704365,
              58.476476669389456
            ],
            [
              -6.338337878866241,
              58.477675874025266
            ],
            [
              -6.363567891080493,
              58.45848368869494
            ],
            [
              -6.4346706527754804,
              58.43567935734063
            ],
            [
              -6.482837039729361,
              58.4068527542677
            ],
            [
              -6.528709789210183,
              58.390026337845
            ],
            [
              -6.540177976579997,
              58.353942678176566
            ],
            [
              -6.574582538689555,
              58.36356859541078
            ],
            [
              -6.615868013222638,
              58.34551784754149
            ],
            [
              -6.654859850279905,
              58.34912873532653
            ],
            [
              -6.723668974500384,
              58.3238447678136
            ],
            [
              -6.755779899136797,
              58.30577371270701
            ],
            [
              -6.801652648617591,
              58.30336354098327
            ],
            [
              -6.822295385884161,
              58.28287045150424
            ],
            [
              -6.7833035488255575,
              58.22977439849578
            ],
            [
              -6.7833035488255575,
              58.21044701876656
            ],
            [
              -6.872755410312578,
              58.27684081403015
            ],
            [
              -6.893398147577784,
              58.25633236658382
            ],
            [
              -6.865874497890445,
              58.212863516752265
            ],
            [
              -6.907159972422107,
              58.21769601938655
            ],
            [
              -6.939270897058549,
              58.2406414256279
            ],
            [
              -6.9667945467472805,
              58.22252786428436
            ],
            [
              -7.031016396018742,
              58.24305586851017
            ],
            [
              -7.056246408232937,
              58.21890404227153
            ],
            [
              -7.056246408232937,
              58.19715334003172
            ],
            [
              -7.031016396018742,
              58.18627299276042
            ],
            [
              -7.0791827829740726,
              58.18869113560379
            ],
            [
              -7.1067064326614116,
              58.17780819713869
            ],
            [
              -7.08606369539487,
              58.164502302776356
            ],
            [
              -7.120468257505763,
              58.13545397747612
            ],
            [
              -7.129642807401126,
              58.11607525455875
            ],
            [
              -7.0998255202392215,
              58.07607333996236
            ],
            [
              -7.08147642044716,
              58.05908927474388
            ],
            [
              -7.0585400457075025,
              58.042097130199465
            ],
            [
              -7.028722758545598,
              58.033598027446175
            ],
            [
              -7.060833683180618,
              58.00565817507993
            ],
            [
              -7.083770057921697,
              58.020238211772494
            ],
            [
              -7.147991907194523,
              58.039669021305286
            ],
            [
              -7.170928281934209,
              58.026311473918724
            ],
            [
              -7.147991907194523,
              58.00201223764421
            ],
            [
              -7.113587345083573,
              58.004442903861275
            ],
            [
              -7.08147642044716,
              57.97039855524858
            ],
            [
              -7.019548142697857,
              57.954581058807435
            ],
            [
              -7.0378972424898905,
              57.913179721770575
            ],
            [
              -7.053952704808836,
              57.893680212297596
            ],
            [
              -7.086063629445221,
              57.891242029618155
            ],
            [
              -7.127349103976968,
              57.8338971204019
            ],
            [
              -7.221388240411642,
              57.78379819389511
            ],
            [
              -7.271848264840088,
              57.772791552590576
            ],
            [
              -7.297078277054311,
              57.720157947015906
            ],
            [
              -7.315427376846401,
              57.68584369719912
            ],
            [
              -7.37276831369698,
              57.65763266429323
            ],
            [
              -7.377355588644605,
              57.63308348660368
            ],
            [
              -7.430109250547616,
              57.65395134605939
            ],
            [
              -7.3704746762224715,
              57.67112763580684
            ],
            [
              -7.446164712865084,
              57.6588596873695
            ],
            [
              -7.492037462345905,
              57.66254050760588
            ],
            [
              -7.503505649715748,
              57.6257154952751
            ],
            [
              -7.542497486774323,
              57.604831401681025
            ],
            [
              -7.496624737293587,
              57.57286780303471
            ],
            [
              -7.430109206605181,
              57.556875459420866
            ],
            [
              -7.397998281968739,
              57.53841403744303
            ],
            [
              -7.361300082384673,
              57.502695423440315
            ],
            [
              -7.370474632281372,
              57.47557520410825
            ],
            [
              -7.409466469339947,
              57.452136984232595
            ],
            [
              -7.391117369547942,
              57.42621409430387
            ],
            [
              -7.393411007021115,
              57.399037076950265
            ],
            [
              -7.427815569132036,
              57.38667721966158
            ],
            [
              -7.402585556917813,
              57.35081005823892
            ],
            [
              -7.395704644495652,
              57.31243051045965
            ],
            [
              -7.418641019235281,
              57.286408676850584
            ],
            [
              -7.4346964815542265,
              57.23927474114788
            ],
            [
              -7.423228294182934,
              57.1933231994154
            ],
            [
              -7.402585556917813,
              57.13984813530311
            ],
            [
              -7.381942819651215,
              57.107476841930435
            ],
            [
              -7.449226804645576,
              57.06633595239583
            ],
            [
              -7.45381407959465,
              57.025162908718926
            ],
            [
              -7.504274104023068,
              57.016423364493676
            ],
            [
              -7.5272104787627825,
              56.97144467778716
            ],
            [
              -7.5570277659246585,
              56.96269250847368
            ],
            [
              -7.577670503191229,
              56.927663265999314
            ],
            [
              -7.651066902359389,
              56.82112277828091
            ],
            [
              -7.660241452256059,
              56.79349811369869
            ],
            [
              -7.6319493440743145,
              56.77717904304879
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Orkney
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -2.9588622214079976,
              58.72912384053271
            ],
            [
              -2.9148173369510744,
              58.73420336885246
            ],
            [
              -2.909923416098991,
              58.75959398479566
            ],
            [
              -2.9343930203608295,
              58.76466988339868
            ],
            [
              -2.9197112578038684,
              58.77735638656759
            ],
            [
              -2.929499099508746,
              58.791306189574044
            ],
            [
              -2.917264297377841,
              58.80778509567102
            ],
            [
              -2.8781129305575064,
              58.81665511170968
            ],
            [
              -2.890347732689179,
              58.82932262849428
            ],
            [
              -2.8585372471476944,
              58.850846786128585
            ],
            [
              -2.6848030568848174,
              58.88879798180062
            ],
            [
              -2.6627804130489494,
              58.90143913283083
            ],
            [
              -2.706825700721396,
              58.92165536122354
            ],
            [
              -2.714166581999507,
              58.940597333174
            ],
            [
              -2.7043787402946293,
              58.95195752798426
            ],
            [
              -2.7043787402946293,
              58.97214419503655
            ],
            [
              -2.7949162760654644,
              58.96962150797742
            ],
            [
              -2.797363236492231,
              58.98853716076036
            ],
            [
              -2.8316206824590324,
              59.02004017782406
            ],
            [
              -2.8047041177703704,
              59.02885585661221
            ],
            [
              -2.819385880328099,
              59.046480436261334
            ],
            [
              -2.797363236492231,
              59.07038505819256
            ],
            [
              -2.797363236492231,
              59.08673126805539
            ],
            [
              -2.6701212943278563,
              59.108095335735015
            ],
            [
              -2.679909136032734,
              59.09678660483894
            ],
            [
              -2.6848030568848174,
              59.076672983359884
            ],
            [
              -2.643204729639166,
              59.08295975678266
            ],
            [
              -2.652992571344072,
              59.101813167936996
            ],
            [
              -2.6211820858025874,
              59.10055659623745
            ],
            [
              -2.5991594419667763,
              59.09301619896826
            ],
            [
              -2.6065003232456547,
              59.06786956560663
            ],
            [
              -2.586924639835786,
              59.08044518561442
            ],
            [
              -2.5649019959992643,
              59.08673126805539
            ],
            [
              -2.5355384708845463,
              59.077930430179606
            ],
            [
              -2.5281975896057247,
              59.09427304697965
            ],
            [
              -2.54777327301548,
              59.10432617319307
            ],
            [
              -2.540432391737369,
              59.124423585349746
            ],
            [
              -2.5893716002618703,
              59.11563241769454
            ],
            [
              -2.6065003232456547,
              59.13321249760233
            ],
            [
              -2.5746898377041703,
              59.14074405612732
            ],
            [
              -2.582030718982992,
              59.15454761123311
            ],
            [
              -2.6162881649505323,
              59.143254207507596
            ],
            [
              -2.6162881649505323,
              59.1532929726219
            ],
            [
              -2.643204729639166,
              59.16332879350071
            ],
            [
              -2.67501521517994,
              59.19717795958067
            ],
            [
              -2.643204729639166,
              59.21346375381913
            ],
            [
              -2.628522967081466,
              59.23349714776239
            ],
            [
              -2.594265521113954,
              59.22974178224791
            ],
            [
              -2.5624550355732367,
              59.215968571292365
            ],
            [
              -2.560008075147209,
              59.23600049509977
            ],
            [
              -2.5037279853438292,
              59.22348192096149
            ],
            [
              -2.533091510458547,
              59.23850365870888
            ],
            [
              -2.5110688666219403,
              59.2510167211432
            ],
            [
              -2.462129658097467,
              59.28227929009631
            ],
            [
              -2.4131904495729373,
              59.2885283614678
            ],
            [
              -2.418084370425049,
              59.31351317676632
            ],
            [
              -2.415637409998965,
              59.34846109927295
            ],
            [
              -2.3960617265892097,
              59.35594526394374
            ],
            [
              -2.4131904495729373,
              59.37464845834461
            ],
            [
              -2.3764860431793693,
              59.38835758307718
            ],
            [
              -2.4278722121299268,
              59.3858654271763
            ],
            [
              -2.449894855966477,
              59.35843961887119
            ],
            [
              -2.537985431310574,
              59.303521452626285
            ],
            [
              -2.5624550355732367,
              59.30601965887834
            ],
            [
              -2.5893716002618703,
              59.28977803807902
            ],
            [
              -2.6138412045244763,
              59.28727863897032
            ],
            [
              -2.596712481540692,
              59.27102807036141
            ],
            [
              -2.62607600665541,
              59.25226777481464
            ],
            [
              -2.6603334526228934,
              59.24100663859929
            ],
            [
              -2.69703785901649,
              59.22222981088015
            ],
            [
              -2.7190605028523294,
              59.234748844397814
            ],
            [
              -2.7410831466881973,
              59.247263284610796
            ],
            [
              -2.763105790524719,
              59.25351878256865
            ],
            [
              -2.7924693156394653,
              59.234748844397814
            ],
            [
              -2.829173722033005,
              59.23600049509977
            ],
            [
              -2.838961563737911,
              59.25351878256865
            ],
            [
              -2.853643326295611,
              59.27102807036141
            ],
            [
              -2.885453811836385,
              59.26852729442132
            ],
            [
              -2.885453811836385,
              59.2885283614678
            ],
            [
              -2.89768861396729,
              59.30227228069131
            ],
            [
              -2.8805598909843013,
              59.33348781964304
            ],
            [
              -2.8805598909843013,
              59.35469801773985
            ],
            [
              -2.88545340862089,
              59.385866231580934
            ],
            [
              -2.949074379703063,
              59.360934595494456
            ],
            [
              -2.9735439839656976,
              59.349709379891834
            ],
            [
              -2.9833318256705468,
              59.333488625290045
            ],
            [
              -3.0298240737690207,
              59.324751163680446
            ],
            [
              -3.0640815197365328,
              59.335984630253904
            ],
            [
              -3.0738693614414387,
              59.32225433340281
            ],
            [
              -3.020036232064143,
              59.30976743043644
            ],
            [
              -3.0175892716373767,
              59.279780147233794
            ],
            [
              -2.949074379703063,
              59.17712405019776
            ],
            [
              -2.980884865243837,
              59.185899437640046
            ],
            [
              -3.0445058363260102,
              59.17712405019776
            ],
            [
              -3.056740638457711,
              59.19843179759454
            ],
            [
              -3.0787632822935507,
              59.199684780766745
            ],
            [
              -3.1179146491131178,
              59.167092276972454
            ],
            [
              -3.1203616095399127,
              59.14576498493304
            ],
            [
              -3.1619599367855358,
              59.13948972165866
            ],
            [
              -3.2206869870156822,
              59.152039097952695
            ],
            [
              -3.3161184436386293,
              59.14199996500753
            ],
            [
              -3.3161184436386293,
              59.12191286398081
            ],
            [
              -3.3503758896061413,
              59.10935244211785
            ],
            [
              -3.345481968753319,
              59.055290150098074
            ],
            [
              -3.3577167708842808,
              59.02633813473392
            ],
            [
              -3.3577167708842808,
              58.96962232223697
            ],
            [
              -3.2989897206548733,
              58.94817202677555
            ],
            [
              -3.3234593249175077,
              58.92418237336955
            ],
            [
              -3.3577167708842808,
              58.93175985485692
            ],
            [
              -3.4237847023932773,
              58.90396762417555
            ],
            [
              -3.440913425377005,
              58.87741780963515
            ],
            [
              -3.3723985334420092,
              58.86476787419468
            ],
            [
              -3.3503758896061413,
              58.82932344606536
            ],
            [
              -3.291648839375995,
              58.77862560084668
            ],
            [
              -3.2378157099986993,
              58.77228316017445
            ],
            [
              -3.2011113036051313,
              58.77989395000583
            ],
            [
              -3.1301494512448187,
              58.7836987195501
            ],
            [
              -3.090998084424484,
              58.82172349161357
            ],
            [
              -3.0126953507852647,
              58.805251206837056
            ],
            [
              -2.980884865243837,
              58.78877109714142
            ],
            [
              -2.980884865243837,
              58.76086384813917
            ],
            [
              -2.9588622214079976,
              58.72912384053271
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Shetland
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [
          [
            [
              -1.2612561716705102,
              59.854864213199676
            ],
            [
              -1.2700564078749892,
              59.88468249235581
            ],
            [
              -1.2700564078749892,
              59.90785703960594
            ],
            [
              -1.292058449190165,
              59.927708071823986
            ],
            [
              -1.2590553872160797,
              59.927708071823986
            ],
            [
              -1.2546549789533117,
              59.94864906091166
            ],
            [
              -1.2502545706905437,
              59.967374528592615
            ],
            [
              -1.2810574285325629,
              59.994892762418914
            ],
            [
              -1.2458541624277188,
              59.981686864892
            ],
            [
              -1.2260523252433018,
              59.99379247221637
            ],
            [
              -1.2062504880587994,
              59.970677924502695
            ],
            [
              -1.182048242611586,
              59.9827875576253
            ],
            [
              -1.1600462012963817,
              59.994892762418914
            ],
            [
              -1.1798480384808556,
              60.00589365219298
            ],
            [
              -1.2216519169805338,
              60.01029298379672
            ],
            [
              -1.2304527335060982,
              60.03118181762076
            ],
            [
              -1.2062504880587994,
              60.036676685202224
            ],
            [
              -1.1666468136912158,
              60.04107192121856
            ],
            [
              -1.1974496715332634,
              60.04656514376293
            ],
            [
              -1.2106508963229032,
              60.06523526604229
            ],
            [
              -1.2062504880587994,
              60.08828378048611
            ],
            [
              -1.223852121111264,
              60.09815678463477
            ],
            [
              -1.1974496715332634,
              60.11570148989156
            ],
            [
              -1.2040502839280691,
              60.12994968260969
            ],
            [
              -1.1688470178232535,
              60.1233743600377
            ],
            [
              -1.1578459971643724,
              60.14638224242455
            ],
            [
              -1.1226427310595,
              60.149667769429215
            ],
            [
              -1.1226427310595,
              60.1200862060968
            ],
            [
              -1.0808388525598502,
              60.109123320583535
            ],
            [
              -1.0104323203501338,
              60.13323685128435
            ],
            [
              -1.0060315365151382,
              60.15295299594882
            ],
            [
              -1.0500356191468256,
              60.166090508645084
            ],
            [
              -1.0720376604620299,
              60.15623786643701
            ],
            [
              -1.0764380687261337,
              60.18906852262796
            ],
            [
              -1.129242967883414,
              60.17922277081317
            ],
            [
              -1.1556454174613862,
              60.18688083291519
            ],
            [
              -1.1556454174613862,
              60.202191599762216
            ],
            [
              -1.2216515414082778,
              60.1682795835882
            ],
            [
              -1.168846642251026,
              60.22514436083776
            ],
            [
              -1.2260519496723532,
              60.20109821041322
            ],
            [
              -1.168846642251026,
              60.241529356891476
            ],
            [
              -1.1336433761461535,
              60.25790616166387
            ],
            [
              -1.0962399059093002,
              60.26663710917069
            ],
            [
              -1.1182419472258118,
              60.27318379152831
            ],
            [
              -1.1512450091985897,
              60.26663710917069
            ],
            [
              -1.1622460298562203,
              60.28081993224379
            ],
            [
              -1.1204421513565421,
              60.30044753866915
            ],
            [
              -1.0808384769889017,
              60.298267275382614
            ],
            [
              -1.0962399059093002,
              60.3124363870694
            ],
            [
              -1.0808384769889017,
              60.325510114165695
            ],
            [
              -0.9884299034627304,
              60.328777728173435
            ],
            [
              -0.9730284745423603,
              60.339667412872814
            ],
            [
              -0.9378252084375163,
              60.36578783422789
            ],
            [
              -0.9026219423313364,
              60.379927661939746
            ],
            [
              -0.750807857254415,
              60.41253462195803
            ],
            [
              -0.7398068365968129,
              60.427740028597015
            ],
            [
              -1.0500356191468256,
              60.44836456876061
            ],
            [
              -1.1160417430937457,
              60.43099740516931
            ],
            [
              -1.1446443968037556,
              60.40384262592178
            ],
            [
              -1.1578456215934239,
              60.379927661939746
            ],
            [
              -1.168846642251026,
              60.421224296258174
            ],
            [
              -1.1666464381189883,
              60.43968214717603
            ],
            [
              -1.1468446009357933,
              60.46029911039781
            ],
            [
              -1.098440110041338,
              60.48632289061635
            ],
            [
              -1.1160417430937457,
              60.5047437778305
            ],
            [
              -1.078638272856864,
              60.49390922933557
            ],
            [
              -1.0324339860944463,
              60.494992847141106
            ],
            [
              -1.0346341902251766,
              60.5047437778305
            ],
            [
              -1.0214329654368157,
              60.53073192322185
            ],
            [
              -1.0412348026199822,
              60.53830787211052
            ],
            [
              -1.0082317406472328,
              60.559943672257674
            ],
            [
              -1.0082317406472328,
              60.57832272814949
            ],
            [
              -0.9972307199896306,
              60.60317188083559
            ],
            [
              -0.9664278621475546,
              60.61181058346506
            ],
            [
              -0.8916209216737627,
              60.56426909614365
            ],
            [
              -0.8586178597009848,
              60.567512784354676
            ],
            [
              -0.9004217382006345,
              60.596691336330935
            ],
            [
              -0.8586178597009848,
              60.5923702505944
            ],
            [
              -0.8168139812013067,
              60.58048428306691
            ],
            [
              -0.7926117357540932,
              60.566431591111694
            ],
            [
              -0.786011123359259,
              60.5869680802559
            ],
            [
              -0.7618088779119887,
              60.60317188083559
            ],
            [
              -0.7794105109643965,
              60.615049500854894
            ],
            [
              -0.8014125522796007,
              60.59777151742017
            ],
            [
              -0.8212143894640747,
              60.60317188083559
            ],
            [
              -0.8300152059909465,
              60.62692274996746
            ],
            [
              -0.8652184720957621,
              60.63231823675147
            ],
            [
              -0.8960213299378381,
              60.62152636033056
            ],
            [
              -0.9268241877786068,
              60.625843544271675
            ],
            [
              -0.9818292910678963,
              60.638791629272106
            ],
            [
              -1.0016311282523986,
              60.64742079744843
            ],
            [
              -0.9752286786730622,
              60.67113909872617
            ],
            [
              -0.929024391910616,
              60.67544964070976
            ],
            [
              -0.880619901016189,
              60.6603602180343
            ],
            [
              -0.8696188803585869,
              60.67113909872617
            ],
            [
              -0.9048221464634025,
              60.690531992305665
            ],
            [
              -0.8542174514381884,
              60.67329444187499
            ],
            [
              -0.8344156142537145,
              60.68622347039903
            ],
            [
              -0.8344156142537145,
              60.696993693221174
            ],
            [
              -0.8718190844906246,
              60.69807051715782
            ],
            [
              -0.849817043174113,
              60.72175152215226
            ],
            [
              -0.8168139812013067,
              60.737887659906505
            ],
            [
              -0.786011123359259,
              60.752940741211546
            ],
            [
              -0.8124135729385671,
              60.762613994111405
            ],
            [
              -0.8234145935961408,
              60.778729600795174
            ],
            [
              -0.8344156142537145,
              60.79268990828217
            ],
            [
              -0.7794105109643965,
              60.78195175011095
            ],
            [
              -0.786011123359259,
              60.80127784373781
            ],
            [
              -0.8080131646744348,
              60.80879039829435
            ],
            [
              -0.7486076531223773,
              60.81630119011285
            ],
            [
              -0.7904115316219986,
              60.81737401649215
            ],
            [
              -0.7794105109643965,
              60.82917273298591
            ],
            [
              -0.8322154101216768,
              60.842039097837926
            ],
            [
              -0.880619901016189,
              60.802351173750736
            ],
            [
              -0.8740192886213549,
              60.842039097837926
            ],
            [
              -0.8960213299378381,
              60.842039097837926
            ],
            [
              -0.9070223505954687,
              60.823810219477906
            ],
            [
              -0.9510264332258487,
              60.79483710804945
            ],
            [
              -0.9312245960426822,
              60.78302572789198
            ],
            [
              -0.9378252084375163,
              60.75401569114757
            ],
            [
              -0.9598272497527205,
              60.73896311416118
            ],
            [
              -0.9532266373578864,
              60.716371007637264
            ],
            [
              -0.9818292910678963,
              60.72175152215226
            ],
            [
              -0.9730284745423603,
              60.692686036863336
            ],
            [
              -1.003831332384408,
              60.701300772612655
            ],
            [
              -1.0214329654368157,
              60.727131135633385
            ],
            [
              -1.0676372521992619,
              60.728206950214485
            ],
            [
              -1.1204421513565421,
              60.729282728759216
            ],
            [
              -1.129242967883414,
              60.70022405685256
            ],
            [
              -1.1336433761461535,
              60.670061373031814
            ],
            [
              -1.1534452133306559,
              60.623685024534126
            ],
            [
              -1.16004582572549,
              60.657125850138385
            ],
            [
              -1.1864482753034622,
              60.62800191954915
            ],
            [
              -1.1996495000930736,
              60.589129056819644
            ],
            [
              -1.184248071172732,
              60.567512784354676
            ],
            [
              -1.1864482753034622,
              60.53614349620642
            ],
            [
              -1.168846642251026,
              60.502577157815864
            ],
            [
              -1.2084503166199454,
              60.48198704307029
            ],
            [
              -1.2370529703299553,
              60.49390922933557
            ],
            [
              -1.2700560323027617,
              60.475482184998725
            ],
            [
              -1.2832572570924015,
              60.489574395949944
            ],
            [
              -1.303059094276847,
              60.47222926687596
            ],
            [
              -1.3272613397240889,
              60.46138385126602
            ],
            [
              -1.3162603190665436,
              60.47873477705585
            ],
            [
              -1.309659706671681,
              60.49715997410934
            ],
            [
              -1.3360621562496533,
              60.496076428732295
            ],
            [
              -1.3206607273293116,
              60.50907658337897
            ],
            [
              -1.358064197566165,
              60.51665759926769
            ],
            [
              -1.3294615438548192,
              60.528567040721526
            ],
            [
              -1.3646648099596632,
              60.528567040721526
            ],
            [
              -1.3272613397240889,
              60.53614349620642
            ],
            [
              -1.3140601149344775,
              60.55237278806325
            ],
            [
              -1.3118599108024114,
              60.58264569338627
            ],
            [
              -1.3008588901448093,
              60.61073087208496
            ],
            [
              -1.3140605517884296,
              60.632318816676985
            ],
            [
              -1.3448634096291983,
              60.626923329989665
            ],
            [
              -1.3514640220240324,
              60.61181116375937
            ],
            [
              -1.3932679005236537,
              60.61289083899433
            ],
            [
              -1.4262709624977958,
              60.62044755419046
            ],
            [
              -1.4306713707605638,
              60.603172461284885
            ],
            [
              -1.4416723914181375,
              60.58912963752147
            ],
            [
              -1.4350717790233318,
              60.577242477379855
            ],
            [
              -1.4680748409974171,
              60.5599442534845
            ],
            [
              -1.4966774947074555,
              60.53722628388448
            ],
            [
              -1.4548736162078058,
              60.51232638947798
            ],
            [
              -1.4812760657871138,
              60.51232638947798
            ],
            [
              -1.5164793318919294,
              60.52748512699782
            ],
            [
              -1.5318812798516035,
              60.55345572636833
            ],
            [
              -1.5670845459577833,
              60.53939128125788
            ],
            [
              -1.5692847500884568,
              60.503661762803205
            ],
            [
              -1.6110886285881634,
              60.51232708393027
            ],
            [
              -1.6286902616405712,
              60.486324168175486
            ],
            [
              -1.6286902616405712,
              60.474399193216954
            ],
            [
              -1.5736851583526175,
              60.481988320800184
            ],
            [
              -1.5472827087733378,
              60.48957567338101
            ],
            [
              -1.4988782178787972,
              60.44945098733615
            ],
            [
              -1.4636749517739815,
              60.47331488721912
            ],
            [
              -1.4592745435112136,
              60.45162115763239
            ],
            [
              -1.4328720939319055,
              60.45162115763239
            ],
            [
              -1.4526739311163794,
              60.43968342657158
            ],
            [
              -1.448273522852304,
              60.414708538558244
            ],
            [
              -1.4152704608794977,
              60.41144952993943
            ],
            [
              -1.4108700526167013,
              60.38754015553474
            ],
            [
              -1.441672910458749,
              60.38862732632225
            ],
            [
              -1.4680753600367495,
              60.37449127476091
            ],
            [
              -1.4614747476419154,
              60.34837782767312
            ],
            [
              -1.4064696443525975,
              60.34837782767312
            ],
            [
              -1.4020692360898295,
              60.33095723948324
            ],
            [
              -1.4240712774050621,
              60.32115407074633
            ],
            [
              -1.4790763806943517,
              60.34184619704777
            ],
            [
              -1.4966780137467879,
              60.329868143877974
            ],
            [
              -1.4900774013519538,
              60.30916842194935
            ],
            [
              -1.5054788302736313,
              60.320064648056615
            ],
            [
              -1.542882300510513,
              60.30480891361202
            ],
            [
              -1.5736851583526175,
              60.29172689799756
            ],
            [
              -1.606688220325367,
              60.30480891361202
            ],
            [
              -1.6308904657726089,
              60.30480891361202
            ],
            [
              -1.6638935277453868,
              60.32333280708886
            ],
            [
              -1.6638935277453868,
              60.337491050032696
            ],
            [
              -1.6902959773246948,
              60.3331353216787
            ],
            [
              -1.7254992434295389,
              60.347289313387506
            ],
            [
              -1.7387004682191787,
              60.335313258526554
            ],
            [
              -1.6968965897195005,
              60.32115407074633
            ],
            [
              -1.6990967938515666,
              60.28845557586706
            ],
            [
              -1.668293936009519,
              60.28082121788921
            ],
            [
              -1.6946963855874628,
              60.25354110121171
            ],
            [
              -1.6792949566671211,
              60.23825430038974
            ],
            [
              -2.084132516874064,
              60.15514423666039
            ],
            [
              -2.1127351705854096,
              60.13433382039983
            ],
            [
              -2.08633272100613,
              60.1255675997439
            ],
            [
              -2.0621304755588596,
              60.11131750981511
            ],
            [
              -1.5362816881157073,
              60.18360031446059
            ],
            [
              -1.5010784220108349,
              60.166091798797794
            ],
            [
              -1.4526739311163794,
              60.14638356113889
            ],
            [
              -1.448273522852304,
              60.1770357147349
            ],
            [
              -1.4152704608794977,
              60.166091798797794
            ],
            [
              -1.3998690319578202,
              60.18469428683866
            ],
            [
              -1.3998690319578202,
              60.215310718463684
            ],
            [
              -1.3646657658529762,
              60.191257355725384
            ],
            [
              -1.344863928669838,
              60.20547283780718
            ],
            [
              -1.298659641906056,
              60.243714691178894
            ],
            [
              -1.3316627038801983,
              60.17375292275614
            ],
            [
              -1.3690661741170516,
              60.142002347964194
            ],
            [
              -1.3690661741170516,
              60.11351023282796
            ],
            [
              -1.3382633162749755,
              60.10693162575063
            ],
            [
              -1.3756667865118857,
              60.045467895117895
            ],
            [
              -1.3624655617222459,
              60.019091215152486
            ],
            [
              -1.314061070827762,
              60.01249375421011
            ],
            [
              -1.344863928669838,
              59.99819473814958
            ],
            [
              -1.3294624997481037,
              59.97288133107409
            ],
            [
              -1.3514645410646438,
              59.98168819020532
            ],
            [
              -1.3602653575902082,
              59.96847702301312
            ],
            [
              -1.3294624997481037,
              59.95085393292308
            ],
            [
              -1.358065153458142,
              59.94424285731478
            ],
            [
              -1.3712663782477819,
              59.926606875687526
            ],
            [
              -1.382267398905384,
              59.91337373428448
            ],
            [
              -1.3800671947746537,
              59.8924104667758
            ],
            [
              -1.3426637245377435,
              59.880267788990125
            ],
            [
              -1.3426637245377435,
              59.89572133617963
            ],
            [
              -1.3206616832225961,
              59.89572133617963
            ],
            [
              -1.3008598460381222,
              59.854864213199676
            ],
            [
              -1.298659641906056,
              59.87143396351135
            ],
            [
              -1.2612561716705102,
              59.854864213199676
            ]
          ]
        ],
        type: 'Polygon'
      }
    },

    { // Mainlaind
      type: 'Feature',
      geometry: {
        coordinates: [
          [
            [
              -2.036492176762721,
              55.791620052091474
            ],
            [
              -2.0810397275998582,
              55.86996703939886
            ],
            [
              -2.2027735914447533,
              55.9235954968718
            ],
            [
              -2.4201554911697656,
              55.96741820582508
            ],
            [
              -2.6201468389155878,
              56.04520285571127
            ],
            [
              -2.7940523586953816,
              56.06947845391059
            ],
            [
              -2.9766531544634347,
              55.9528161460326
            ],
            [
              -3.1679492262209976,
              55.97714985208793
            ],
            [
              -3.3766358499551075,
              56.03063016071641
            ],
            [
              -3.1592539502314025,
              56.07918441479498
            ],
            [
              -2.9592626024855235,
              56.20997578947154
            ],
            [
              -2.811442910673179,
              56.18578873557561
            ],
            [
              -2.576670458970341,
              56.27761843660298
            ],
            [
              -2.802747634683641,
              56.34032252540777
            ],
            [
              -2.7853570827057865,
              56.42697374203914
            ],
            [
              -2.9592626024855235,
              56.46061822302059
            ],
            [
              -2.7418807027605396,
              56.47502816985511
            ],
            [
              -2.4462413191358507,
              56.604471763032365
            ],
            [
              -2.5158035270485755,
              56.65230160376376
            ],
            [
              -2.3940696632023446,
              56.76684606784494
            ],
            [
              -2.194078315456494,
              56.92377589940864
            ],
            [
              -2.24624997139,
              56.97120057473617
            ],
            [
              -2.054953899632409,
              57.12727439555215
            ],
            [
              -2.0897350035893965,
              57.179153345528334
            ],
            [
              -1.98539169172102,
              57.320271907764464
            ],
            [
              -1.7767050679855743,
              57.46552739992268
            ],
            [
              -1.8201814479308496,
              57.61020790785312
            ],
            [
              -2.054953899632409,
              57.703245663181605
            ],
            [
              -2.167992487489073,
              57.67070958518619
            ],
            [
              -2.3071169033131014,
              57.69395262154072
            ],
            [
              -2.481022423091588,
              57.661408196780314
            ],
            [
              -2.907090946551989,
              57.71718075582501
            ],
            [
              -3.0114342584190865,
              57.65210442275924
            ],
            [
              -3.307073642043747,
              57.72646783824479
            ],
            [
              -3.4896744378117717,
              57.69395262154072
            ],
            [
              -3.715751613525015,
              57.656756607994566
            ],
            [
              -3.846180753359505,
              57.59157171695588
            ],
            [
              -4.1244295850063395,
              57.59157171695588
            ],
            [
              -3.767923269458578,
              57.85623693987333
            ],
            [
              -3.9418287892383432,
              57.86086292479595
            ],
            [
              -4.011390997149675,
              57.80067873887279
            ],
            [
              -4.228772896874716,
              57.86086292479595
            ],
            [
              -4.011390997149675,
              57.87011311141305
            ],
            [
              -4.011390997149675,
              57.94402905164446
            ],
            [
              -3.8548760293491,
              58.04081314335383
            ],
            [
              -3.6548846816019136,
              58.10519065412646
            ],
            [
              -3.3766358499551075,
              58.28391661756001
            ],
            [
              -3.176644502209257,
              58.32959909423769
            ],
            [
              -3.037520086386479,
              58.48902371563685
            ],
            [
              -3.13316812226401,
              58.4981119185866
            ],
            [
              -3.020129534408653,
              58.63415297995189
            ],
            [
              -3.3853311259447025,
              58.66581989784149
            ],
            [
              -3.4114169539121235,
              58.597927026932894
            ],
            [
              -3.5853224736905247,
              58.620572647477815
            ],
            [
              -3.7766185454481445,
              58.56166351480155
            ],
            [
              -4.02878154912753,
              58.5933961424312
            ],
            [
              -4.220077620885121,
              58.538979735889114
            ],
            [
              -4.411373692642741,
              58.538979735889114
            ],
            [
              -4.559193384455057,
              58.5797999672821
            ],
            [
              -4.654841420333838,
              58.53444121785577
            ],
            [
              -4.802661112146183,
              58.588864671020616
            ],
            [
              -4.985261907914207,
              58.62962678900374
            ],
            [
              -5.098300495770843,
              58.49356811108959
            ],
            [
              -5.16786270368226,
              58.4162333876817
            ],
            [
              -5.185253255660058,
              58.375222604937335
            ],
            [
              -5.115691047748669,
              58.251903773885175
            ],
            [
              -5.385244603405937,
              58.270200369141946
            ],
            [
              -5.27220601555058,
              58.13733589239172
            ],
            [
              -5.289596567528434,
              58.07301640978682
            ],
            [
              -5.428720983351184,
              58.128154497470234
            ],
            [
              -5.446111535329038,
              58.05921856454569
            ],
            [
              -5.185253255660058,
              57.91632839198027
            ],
            [
              -5.376549327417649,
              57.91632839198027
            ],
            [
              -5.454806811318605,
              57.85623693987333
            ],
            [
              -5.64610456257401,
              57.888608118663086
            ],
            [
              -5.793924254386297,
              57.86086469178832
            ],
            [
              -5.793924254386297,
              57.76823199579266
            ],
            [
              -5.759143150430617,
              57.69860121533057
            ],
            [
              -5.811314806364152,
              57.64745341848459
            ],
            [
              -5.64610456257401,
              57.52160267554035
            ],
            [
              -5.828705358341978,
              57.572927753723405
            ],
            [
              -5.846095910319832,
              57.43277986767177
            ],
            [
              -5.7504478744410505,
              57.30148910589736
            ],
            [
              -5.846095910319832,
              57.259188667766296
            ],
            [
              -5.98522032614386,
              57.32496835062631
            ],
            [
              -5.976525050154322,
              57.56826482479991
            ],
            [
              -6.1504305699340875,
              57.43277986767177
            ],
            [
              -6.193906949877999,
              57.62883632660308
            ],
            [
              -6.3156408137242295,
              57.70789306448813
            ],
            [
              -6.437374677569153,
              57.656758384995044
            ],
            [
              -6.385203021635618,
              57.577590085374254
            ],
            [
              -6.411288849603039,
              57.48422991860076
            ],
            [
              -6.628670749326744,
              57.61020968713285
            ],
            [
              -6.602584921359323,
              57.516933173609374
            ],
            [
              -6.602584921359323,
              57.442139808350106
            ],
            [
              -6.750404613171639,
              57.50759237624362
            ],
            [
              -6.750404613171639,
              57.39063049685447
            ],
            [
              -6.567803817403643,
              57.33904870098115
            ],
            [
              -6.550413265425817,
              57.40468567689828
            ],
            [
              -6.411288849603039,
              57.34374095195608
            ],
            [
              -6.4895463335026875,
              57.30148910589736
            ],
            [
              -6.306945537734663,
              57.174441884152515
            ],
            [
              -6.072173086033104,
              57.12727619840979
            ],
            [
              -6.020001430099597,
              57.20742209520077
            ],
            [
              -5.863486462297715,
              57.17915514585894
            ],
            [
              -6.028696706087857,
              57.070597965477305
            ],
            [
              -5.976525050154322,
              57.02329987734899
            ],
            [
              -5.672190390540095,
              57.23096136388264
            ],
            [
              -5.672190390540095,
              57.11783584395195
            ],
            [
              -5.802619530374585,
              57.00909870337705
            ],
            [
              -5.9156581182311925,
              56.89054453711469
            ],
            [
              -5.7504478744410505,
              56.86678844239847
            ],
            [
              -5.820010082352383,
              56.77637752339541
            ],
            [
              -5.950439222186901,
              56.77637752339541
            ],
            [
              -6.185211673889739,
              56.73824446310124
            ],
            [
              -6.185211673889739,
              56.680972243272635
            ],
            [
              -5.7243620464749085,
              56.714391633274744
            ],
            [
              -5.9939156021321764,
              56.642742311174345
            ],
            [
              -5.9156581182311925,
              56.5661660612937
            ],
            [
              -5.660806607665336,
              56.50741714784772
            ],
            [
              -5.1588239995065805,
              56.77791495346875
            ],
            [
              -5.419854955749088,
              56.49633518553486
            ],
            [
              -5.570449738196601,
              56.37421971748401
            ],
            [
              -5.680885911991595,
              56.22939520878603
            ],
            [
              -5.5503704338703415,
              56.10642223689544
            ],
            [
              -5.680885911991595,
              55.977438162986886
            ],
            [
              -5.650766955501467,
              55.870560628698115
            ],
            [
              -5.590529042522775,
              55.752089657245875
            ],
            [
              -5.690925564154725,
              55.48563170797715
            ],
            [
              -5.77124278145962,
              55.38310385753468
            ],
            [
              -5.77124278145962,
              55.286027324530124
            ],
            [
              -5.530291129544139,
              55.343159970779084
            ],
            [
              -5.480092868727752,
              55.655920278962384
            ],
            [
              -5.319458434117223,
              55.780329744145405
            ],
            [
              -5.379696347096655,
              56.02796154445994
            ],
            [
              -5.3094187819540934,
              55.876193111505216
            ],
            [
              -5.16886365166971,
              55.84238595792513
            ],
            [
              -5.028308521385355,
              55.72382911107783
            ],
            [
              -4.988149912732894,
              55.870560628698115
            ],
            [
              -4.84759478244851,
              55.93809651671842
            ],
            [
              -4.897793043264073,
              55.72382911107783
            ],
            [
              -4.827515478122308,
              55.67290854527582
            ],
            [
              -4.666881043511694,
              55.60491122297901
            ],
            [
              -4.616682782696131,
              55.47425287260097
            ],
            [
              -4.727118956490358,
              55.41161053030484
            ],
            [
              -4.837555130285438,
              55.33174002662693
            ],
            [
              -4.84759478244851,
              55.217359440601484
            ],
            [
              -5.078506782201686,
              55.06817170670959
            ],
            [
              -5.018268869222254,
              54.93573261935924
            ],
            [
              -5.118665390854119,
              55.027910439055745
            ],
            [
              -5.188942955995941,
              54.9068836329771
            ],
            [
              -4.8877533911010005,
              54.6346909014884
            ],
            [
              -4.94799130408046,
              54.83177942911604
            ],
            [
              -4.827515478122308,
              54.86646029426589
            ],
            [
              -4.345612174290494,
              54.68115094007962
            ],
            [
              -4.335572522127421,
              54.814427815231966
            ],
            [
              -4.405850087269187,
              54.8895643113149
            ],
            [
              -4.2452156526585725,
              54.849123588255964
            ],
            [
              -4.034382957232424,
              54.75653524178267
            ],
            [
              -3.843629566132506,
              54.843343030081286
            ],
            [
              -3.572558957726841,
              54.86646029426589
            ],
            [
              -3.572558957726841,
              54.97608645851389
            ],
            [
              -3.0304177409155955,
              54.97032410524196
            ],
            [
              -3.0203780887525227,
              55.05092183393586
            ],
            [
              -2.9199815671213685,
              55.062422575033736
            ],
            [
              -2.7493074803468858,
              55.148572865244745
            ],
            [
              -2.6187920022263995,
              55.26887147506244
            ],
            [
              -2.5183954805945064,
              55.32602882006162
            ],
            [
              -2.307562785167562,
              55.40591084028958
            ],
            [
              -2.1569680027201343,
              55.45717845843569
            ],
            [
              -2.307562785167562,
              55.638924637611865
            ],
            [
              -2.207166263536436,
              55.6445906709493
            ],
            [
              -2.036492176762721,
              55.791620052091474
            ]
          ]
        ],
        type: 'Polygon'
      }
    }
  ]
}

const Wales = {
  type: 'Feature',
  properties: {
    centre: [52.45, -3.48]
  },
  geometry: {
    coordinates: [
      [
        [
          -2.6600932569898816,
          51.59896294734335
        ],
        [
          -2.6667239286675226,
          51.64836070867227
        ],
        [
          -2.6733546003461583,
          51.730570837426455
        ],
        [
          -2.646831913634543,
          51.82902598646251
        ],
        [
          -2.7330306454460924,
          51.83722088631214
        ],
        [
          -2.7661840038353773,
          51.878173019718986
        ],
        [
          -2.872274750679992,
          51.931355081146165
        ],
        [
          -2.9651041541701773,
          51.90681733854643
        ],
        [
          -3.097717587726379,
          52.00488786060632
        ],
        [
          -3.097717587726379,
          52.05384270177967
        ],
        [
          -3.1242402744370565,
          52.10274396024977
        ],
        [
          -3.1043482594040483,
          52.159727736662234
        ],
        [
          -3.0513028859817553,
          52.24100674440007
        ],
        [
          -2.9982575125585242,
          52.281590519003856
        ],
        [
          -2.9651041541701773,
          52.34644732390629
        ],
        [
          -3.0513028859817553,
          52.34644732390629
        ],
        [
          -3.2237003496049113,
          52.44759589995161
        ],
        [
          -3.0513028859817553,
          52.50010156272933
        ],
        [
          -2.991626840880855,
          52.532381607443256
        ],
        [
          -2.991626840880855,
          52.57269832024545
        ],
        [
          -3.1176096027593587,
          52.53641494568828
        ],
        [
          -3.1242402744370565,
          52.58075721818517
        ],
        [
          -3.03804154262545,
          52.70146299746409
        ],
        [
          -2.9651041541701773,
          52.72556419254826
        ],
        [
          -3.1375016177933333,
          52.78976896844122
        ],
        [
          -3.1507629611486436,
          52.84186568083447
        ],
        [
          -3.0910869160487096,
          52.92988714989781
        ],
        [
          -2.9717348258478182,
          52.969837848207845
        ],
        [
          -2.9186894524246156,
          52.937880241642034
        ],
        [
          -2.8523827356469837,
          52.94986711149846
        ],
        [
          -2.7993373622246907,
          52.90589901654357
        ],
        [
          -2.726399973768423,
          52.9258900504297
        ],
        [
          -2.726399973768423,
          52.98580779688544
        ],
        [
          -2.832490720613009,
          52.9937905579844
        ],
        [
          -2.8921667657139096,
          53.113355000264136
        ],
        [
          -2.9849961692031854,
          53.15313611660051
        ],
        [
          -2.9253201241032514,
          53.17698710989882
        ],
        [
          -3.071194901014735,
          53.252427834990016
        ],
        [
          -3.1839163195379854,
          53.272258581263856
        ],
        [
          -3.30326840973882,
          53.34753157722665
        ],
        [
          -3.5486032618172487,
          53.31189249149389
        ],
        [
          -3.721000725441371,
          53.30000617931361
        ],
        [
          -3.8536141589975728,
          53.34357314901885
        ],
        [
          -3.8403528156412676,
          53.30000617931361
        ],
        [
          -3.900028860742225,
          53.284152615433385
        ],
        [
          -4.105579682754666,
          53.22067951118794
        ],
        [
          -4.052534309332344,
          53.307930755091974
        ],
        [
          -4.112210354432307,
          53.31981486139895
        ],
        [
          -4.191778414566215,
          53.284152615433385
        ],
        [
          -4.271346474700152,
          53.36731820605061
        ],
        [
          -4.277977146377793,
          53.41476864152435
        ],
        [
          -4.423851923289334,
          53.426622986427844
        ],
        [
          -4.576357371879482,
          53.39895770686908
        ],
        [
          -4.549834685167838,
          53.284152615433385
        ],
        [
          -4.64266408865808,
          53.34357314901885
        ],
        [
          -4.6758174470463985,
          53.30000617931361
        ],
        [
          -4.536573341812527,
          53.236556616491356
        ],
        [
          -4.503419983423214,
          53.19288040888233
        ],
        [
          -4.403959908256326,
          53.15711220266431
        ],
        [
          -4.3310225198000865,
          53.105394356796324
        ],
        [
          -4.410590579933995,
          53.00576193341465
        ],
        [
          -4.556465356846502,
          52.9418762339474
        ],
        [
          -4.762016178857948,
          52.78976896844122
        ],
        [
          -4.596249386913456,
          52.82183587328407
        ],
        [
          -4.529942670134858,
          52.78174854674651
        ],
        [
          -4.4702666250348955,
          52.78976896844122
        ],
        [
          -4.496789311745573,
          52.84186568083447
        ],
        [
          -4.423851923289334,
          52.877896064120335
        ],
        [
          -4.205039757921554,
          52.91789474422771
        ],
        [
          -4.138733041143951,
          52.885898753744044
        ],
        [
          -4.138733041143951,
          52.805805377019055
        ],
        [
          -4.045903637653737,
          52.721548251302835
        ],
        [
          -3.9331822191314814,
          52.75366542746514
        ],
        [
          -4.112210354432307,
          52.62907950296301
        ],
        [
          -4.065795652687683,
          52.55254459406808
        ],
        [
          -3.9398128908091508,
          52.55657608008292
        ],
        [
          -4.03264229429837,
          52.50817379722946
        ],
        [
          -4.092318339398332,
          52.40716429029686
        ],
        [
          -4.185147742888574,
          52.27347673529559
        ],
        [
          -4.384067893222351,
          52.20851297857814
        ],
        [
          -4.4702666250348955,
          52.16786232722484
        ],
        [
          -4.695709462080345,
          52.11496090527055
        ],
        [
          -4.8084308806035665,
          52.04568728322573
        ],
        [
          -4.974197672549025,
          52.021212096049055
        ],
        [
          -5.0736577477159415,
          52.021212096049055
        ],
        [
          -5.080288419393639,
          51.96405121184728
        ],
        [
          -5.252685883016767,
          51.919087886266794
        ],
        [
          -5.3256232714730345,
          51.865891293309744
        ],
        [
          -5.106811106105226,
          51.84951044012956
        ],
        [
          -5.106811106105226,
          51.775722782414476
        ],
        [
          -5.239424539661428,
          51.73467742511036
        ],
        [
          -5.146595136172209,
          51.71003230174409
        ],
        [
          -4.954305657515107,
          51.68537374326152
        ],
        [
          -5.106811106105226,
          51.66892723895958
        ],
        [
          -5.047135061004326,
          51.615434843352006
        ],
        [
          -4.934413642482099,
          51.59484403952254
        ],
        [
          -4.868106925703501,
          51.63190076352507
        ],
        [
          -4.801800208924931,
          51.63190076352507
        ],
        [
          -4.689078790402704,
          51.68126267712918
        ],
        [
          -4.66255610369106,
          51.730570837426455
        ],
        [
          -4.483527968390206,
          51.7387836396733
        ],
        [
          -4.370806549867012,
          51.71824883552105
        ],
        [
          -4.291238489733104,
          51.66892723895958
        ],
        [
          -4.205039757921554,
          51.68537374326152
        ],
        [
          -4.0724263243653525,
          51.65658844086374
        ],
        [
          -4.258085131343819,
          51.63601630993884
        ],
        [
          -4.29786916141083,
          51.582485074692784
        ],
        [
          -4.191778414566215,
          51.54538800496505
        ],
        [
          -3.9862275925537745,
          51.566001224595766
        ],
        [
          -3.959704905842102,
          51.61955188359826
        ],
        [
          -3.846983487319932,
          51.61955188359826
        ],
        [
          -3.7143700537627353,
          51.47110304652267
        ],
        [
          -3.6348019936298215,
          51.47110304652267
        ],
        [
          -3.5552339334958845,
          51.40083378810206
        ],
        [
          -3.3960978132280673,
          51.38014578432677
        ],
        [
          -3.1640243045039824,
          51.404970266397555
        ],
        [
          -3.1242402744370565,
          51.48762128248174
        ],
        [
          -2.978365497525516,
          51.5371401012776
        ],
        [
          -2.912058780746918,
          51.52476544275234
        ],
        [
          -2.772814675513075,
          51.570122747549675
        ],
        [
          -2.6600932569898816,
          51.59896294734335
        ]
      ]
    ],
    type: 'Polygon'
  }
}

const GB = {
  type: 'FeatureCollection',
  features: [England, Scotland, Wales]
}

export default {
  GB, Wales, England, Scotland
}
